import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#let (element this.componentTag) as |Tag|}}\n  <Tag class={{this.classNames}} ...attributes>\n    {{yield}}\n  </Tag>\n{{/let}}")